import { render, staticRenderFns } from "./ProductSearchResultView.vue?vue&type=template&id=1105bbcc&scoped=true"
import script from "./ProductSearchResultView.vue?vue&type=script&lang=js"
export * from "./ProductSearchResultView.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchResultView.vue?vue&type=style&index=0&id=1105bbcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105bbcc",
  null
  
)

export default component.exports